export const Nextplayer = ({info}) => {
    return (
        <button className="btn btn-secondary" id="next-player">
                {info}
        </button>
    )
}